import type { ReactNode } from 'react';

import { FormField, Select } from './FormField';

interface SelectWithCaptionProps {
  htmlFor: string;
  label: string;
  caption?: string;
  value: string;
  onChange: (value: string) => void;
  children: ReactNode;
}

/** A Select with a small explanatory line underneath (Reported Currency, Governing Policy). */
export function SelectWithCaption({
  htmlFor,
  label,
  caption,
  value,
  onChange,
  children,
}: SelectWithCaptionProps) {
  return (
    <FormField htmlFor={htmlFor} label={label}>
      <Select id={htmlFor} onChange={(event) => onChange(event.target.value)} value={value}>
        {children}
      </Select>
      {caption && <p className="rfp-field__caption">{caption}</p>}
    </FormField>
  );
}
